import { BaseNodeDataType } from "../../../../components/Workflow/WorkflowUtils";

import { QuerySetType, UAction, UseCaseType } from "@supportinitiative/common";
import RawQuery from "./RawQuery/RawQuery";

type ActionRouterProps = {
  from: "QUERYSET";
  node: BaseNodeDataType;
  actions: UAction[];
  query?: QuerySetType["definition"]["queries"][number];
  cancel: () => void;
  save: (values: any) => void;
};

export default function ActionRouter(props: ActionRouterProps) {
  const { from, node, actions, save, cancel, query } = props;

  const action = actions.find((a) => a.id === node.id);

  if (action) {
    if (from.toUpperCase() === "QUERYSET") {
      if (action.type.toUpperCase() === "DATALOAD") {
        return <></>;
      } else if (action.type.toUpperCase() === "RAW_QUERY") {
        return <RawQuery save={save} cancel={cancel} action={action} />;
      }
    }
  }

  return <></>;
}
